import * as actions from "../constants/actionTypes";

export const INITIAL_STATE = {
    contestData: {
        aboutSelf: "",
        contestCategory: "",
        contestName: "",
        enrolledDate: "",
        flagAcceptTerms: true,
        flagCreatingForSomeoneElse: false,
        flagInfoProvidedCorrect: true,
        introductionVideo: [],
        isMonthlyWinner: false,
        media: [],
        metadata: {
            countryCode: "",
            email: "",
            firstName: "",
            gender: "",
            lastName: "",
            locationInfo: {
                state: "",
                city: "",
                country: "",
                countryName: "",
                countryFlag: ""
            },
            medias: [],
            phone: "",
            profilePic: "",
        },
        rank: 0,
        todaysVotes: 0,
        votes: 0,
        votesByMe: [],
        weight: 0,
    },
    contestMedia: [],
    hasMore: true,
    contestProfileLoader: true,
    uploadMediaLoader: false,
    uploadMediaLoaderLabel: '',
    viewProfilePic: false,
    viewIntroVideo: false,
    votingStats: [],
    hostEvalutedData: [],
    checkIfNoData: 'waiting'
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case actions.GET_USER_CONTEST_PROFILE_DATA:
            return {
                ...state,
                checkIfNoData: 'waiting'
            }
        case actions.GET_USER_CONTEST_PROFILE_DATA_SUCCESS:
            localStorage.setItem("loadMoreContestProfile", false);
            console.log('PAYLOAD DATATATATATATTATAT', action.payload)
            return {
                ...state,
                contestData: action.payload.contestData,
                contestMedia: action.payload.contestMedia,
                hasMore: action.payload.contestMedia.length >= 20,
                contestProfileLoader: false,
                votingStats: action.payload.votingStats,
                hostEvalutedData: action.payload.hostEvalutedData,
                checkIfNoData: Object.keys(action.payload.contestData).length !== 0 ? 'doneWithData' : 'noData'
            }
        case actions.GET_USER_CONTEST_PROFILE_MEDIA_SUCCESS:
            return {
                ...state,
                contestMedia: [...state.contestMedia, ...action.payload],
                hasMore: action.payload.length >= 20,
                contestProfileLoader: false,
            }
        case actions.SHOW_CONTEST_PROFILE_VIEW_PROFILE_PIC:
            return {
                ...state,
                viewProfilePic: true,
            }
        case actions.HIDE_CONTEST_PROFILE_VIEW_PROFILE_PIC:
            return {
                ...state,
                viewProfilePic: false,
            }
        case actions.SHOW_CONTEST_PROFILE_VIEW_INTRO_VIDEO:
            return {
                ...state,
                viewIntroVideo: true,
            }
        case actions.HIDE_CONTEST_PROFILE_VIEW_INTRO_VIDEO:
            return {
                ...state,
                viewIntroVideo: false,
            }
        case actions.SHOW_UPLOAD_MEDIA_LOADER:
            return {
                ...state,
                uploadMediaLoader: true,
                uploadMediaLoaderLabel: action.payload != undefined ? action.payload : ''
            }
        case actions.HIDE_UPLOAD_MEDIA_LOADER:
            return {
                ...state,
                uploadMediaLoader: false,
                uploadMediaLoaderLabel: ''
            }
        case actions.UPDATE_PROFILE_MEDIA_SUCCESS:
            return {
                ...state,
                contestData: action.payload,
            }
        case actions.RESET_CONTEST_PROFILE:
            return {
                contestData: {
                    aboutSelf: "",
                    contestCategory: "",
                    contestName: "",
                    enrolledDate: "",
                    flagAcceptTerms: true,
                    flagCreatingForSomeoneElse: false,
                    flagInfoProvidedCorrect: true,
                    introductionVideo: [],
                    isMonthlyWinner: false,
                    media: [],
                    metadata: {
                        countryCode: "",
                        email: "",
                        firstName: "",
                        gender: "",
                        lastName: "",
                        locationInfo: {
                            state: "",
                            city: "",
                            country: "",
                            countryName: "",
                            countryFlag: ""
                        },
                        medias: [],
                        phone: "",
                        profilePic: "",
                    },
                    rank: 0,
                    todaysVotes: 0,
                    votes: 0,
                    votesByMe: [],
                    weight: 0,
                },
                contestMedia: [],
                hasMore: true,
                contestProfileLoader: true,
                uploadMediaLoader: false,
                uploadMediaLoaderLabel: '',
                viewProfilePic: false,
                viewIntroVideo: false,
                votingStats: [],
                hostEvalutedData: [], 
                checkIfNoData: 'waiting'
            }
        case actions.UPDATE_MEDIA_VIEW_COUNT_CONTESTPROFILE_SUCCESS: {
            let newContestMedia = state.contestMedia.map((item, index) => {
                if (index === action.payload.index) {
                    return {
                        ...item,
                        viewCount: item.viewCount + 1
                    }
                }
                return item;
            });
            return {
                ...state,
                contestMedia: newContestMedia
            }
        }
        case actions.CONTEST_ERROR: 
            return {
                ...state,
                contestProfileLoader: false
            }
        
        default:
            return state;
    }
}